import { useInstitutionOnboardingBasePath } from '@/features/institution/context/update';
import { useInstitutionDetailsLocked, useInstitutionDetailsV2Answers } from '@/features/institution/hooks/useInstitutionDetails';
import { getPrecedingV2OnboardingDetailsKey, getV2OnboardingDetailsKeyRoute } from '@/features/institution/utils';
import type { InstitutionDetailsV2OnboardingKey } from '@/services/api/profile';

// Back skips sections that don't apply and fully locked ones, which the details layout sends straight on to the review
export const useInstitutionOnboardingPrevDetailsRoute = (key: InstitutionDetailsV2OnboardingKey) => {
  const onboardingPath = useInstitutionOnboardingBasePath();
  const { data: institutionDetailsAnswers } = useInstitutionDetailsV2Answers();
  const { fullyLockedKeys } = useInstitutionDetailsLocked();
  const prevKey = getPrecedingV2OnboardingDetailsKey(institutionDetailsAnswers, key, fullyLockedKeys);

  return prevKey ? getV2OnboardingDetailsKeyRoute(onboardingPath, prevKey) : onboardingPath;
};
